import { useEffect, useState } from "react";
import api, { API_BASE } from "../auth/api";

export default function MetaConnections() {
  const [connections, setConnections] = useState([]);
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showAppModal, setShowAppModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // Form general (crear / editar)
  const [form, setForm] = useState({
    id: null,
    app_id: "",
    app_secret: "",
    redirect_uri: "",
    name: "",
    is_global: 0,
  });

  const [selectedApp, setSelectedApp] = useState("");

  // ===================== CARGA INICIAL =====================
  const loadConnections = async () => {
    const res = await api.get("/api/meta/connections");
    setConnections(res.data);
  };

  const loadApps = async () => {
    const res = await api.get("/api/meta/apps");
    setApps(res.data);

    if (res.data.length > 0 && !selectedApp) {
      setSelectedApp(res.data[0].id);
    }
  };

  useEffect(() => {
    loadConnections();
    loadApps();
  }, []);

  // ===================== CREAR APP =====================
  const createApp = async () => {
    try {
      await api.post("/api/meta/apps", form);
      setShowAppModal(false);
      loadApps();
      alert("Meta App creada correctamente.");
    } catch (err) {
      console.error(err);
      alert("Error creando Meta App");
    }
  };

  // ===================== EDITAR APP =====================
  const updateApp = async () => {
    try {
      await api.put(`/api/meta/apps/${form.id}`, form);
      setShowEditModal(false);
      loadApps();
      alert("Meta App actualizada.");
    } catch (err) {
      console.error(err);
      alert("Error actualizando Meta App");
    }
  };

  // ===================== ELIMINAR APP =====================
  const deleteApp = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta Meta App?")) return;

    try {
      await api.delete(`/api/meta/apps/${id}`);
      loadApps();
      alert("App eliminada correctamente.");
    } catch (err) {
      console.error(err);
      alert("Error eliminando la App");
    }
  };

  // ===================== LOGIN META =====================
  const connectMeta = () => {
    if (!selectedApp) {
      alert("Seleccione una Meta App primero.");
      return;
    }

    window.open(
      `${API_BASE}/api/meta/auth/login?app_id=${selectedApp}`,
      "_blank",
      "width=600,height=700"
    );

    setTimeout(loadConnections, 3000);
  };

  // ===================== CONEXIONES FACEBOOK =====================
  const deleteConnection = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta conexión?")) return;

    await api.delete(`/api/meta/connections/${id}`);
    loadConnections();
  };

  const syncPages = async (connectionId) => {
    setLoading(true);
    try {
      await api.get(`/api/meta/pages/sync/${connectionId}`);
      alert("Páginas sincronizadas correctamente.");
    } catch (e) {
      console.error(e);
      alert("Error al sincronizar páginas");
    }
    setLoading(false);
  };

  return (
    <div className="p-6 text-white">
      <h1 className="text-2xl font-bold mb-4">Conexiones Meta/Facebook</h1>

      {/* ===================== SELECT DE APPS ===================== */}
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={() => {
            setForm({
              id: null,
              app_id: "",
              app_secret: "",
              redirect_uri: "",
              name: "",
              is_global: 0,
            });
            setShowAppModal(true);
          }}
          className="bg-green-600 px-4 py-2 rounded hover:bg-green-500"
        >
          ⚙️ Nueva Meta App
        </button>

        <select
          className="bg-gray-800 p-2 rounded"
          value={selectedApp}
          onChange={(e) => setSelectedApp(e.target.value)}
        >
          {apps.map((app) => (
            <option key={app.id} value={app.id}>
              {app.name || app.app_id} {app.is_global ? "🌍" : ""}
            </option>
          ))}
        </select>

        <button
          onClick={connectMeta}
          className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-500"
        >
          ➕ Conectar con Meta (OAuth)
        </button>
      </div>

      {/* ===================== TABLA DE APPS ===================== */}
      <h2 className="text-xl font-bold mt-8 mb-2">Mis Meta Apps</h2>

      <table className="w-full bg-gray-800 rounded overflow-hidden">
        <thead className="bg-gray-700 text-left">
          <tr>
            <th className="p-3">Nombre</th>
            <th className="p-3">App ID</th>
            <th className="p-3">Global</th>
            <th className="p-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {apps.length === 0 && (
            <tr>
              <td colSpan="4" className="p-3 text-gray-400">
                No hay Meta Apps creadas.
              </td>
            </tr>
          )}

          {apps.map((app) => (
            <tr key={app.id} className="border-t border-gray-700">
              <td className="p-3">{app.name || "Sin nombre"}</td>
              <td className="p-3">{app.app_id}</td>
              <td className="p-3">{app.is_global ? "🌍 Sí" : "No"}</td>
              <td className="p-3 flex gap-2">
                <button
                  onClick={() => {
                    setForm(app);
                    setShowEditModal(true);
                  }}
                  className="bg-yellow-600 px-3 py-1 rounded hover:bg-yellow-500"
                >
                  ✏️ Editar
                </button>

                <button
                  onClick={() => deleteApp(app.id)}
                  className="bg-red-600 px-3 py-1 rounded hover:bg-red-500"
                >
                  🗑 Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===================== TABLA DE CONEXIONES ===================== */}
      <table className="w-full mt-6 bg-gray-800 rounded overflow-hidden">
        <thead className="bg-gray-700 text-left">
          <tr>
            <th className="p-3">ID</th>
            <th className="p-3">Meta User ID</th>
            <th className="p-3">Token (corto)</th>
            <th className="p-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {connections.length === 0 && (
            <tr>
              <td className="p-3 text-gray-400" colSpan="4">
                No hay conexiones.
              </td>
            </tr>
          )}

          {connections.map((c) => (
            <tr key={c.id} className="border-t border-gray-700">
              <td className="p-3">{c.id}</td>
              <td className="p-3">{c.meta_user_id}</td>
              <td className="p-3">{c.access_token.substring(0, 20)}...</td>
              <td className="p-3 flex gap-2">
                <button
                  onClick={() => syncPages(c.id)}
                  disabled={loading}
                  className="bg-green-600 px-3 py-1 rounded hover:bg-green-500"
                >
                  🔄 Sincronizar Páginas
                </button>

                <button
                  onClick={() => deleteConnection(c.id)}
                  className="bg-red-600 px-3 py-1 rounded hover:bg-red-500"
                >
                  🗑 Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===================== MODAL CREAR APP ===================== */}
      {showAppModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center">
          <div className="bg-gray-900 p-6 rounded w-96">
            <h2 className="text-xl font-bold mb-4">Nueva Meta App</h2>

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="App ID"
              onChange={(e) => setForm({ ...form, app_id: e.target.value })}
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="App Secret"
              onChange={(e) => setForm({ ...form, app_secret: e.target.value })}
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="Redirect URI"
              onChange={(e) =>
                setForm({ ...form, redirect_uri: e.target.value })
              }
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="Nombre (opcional)"
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <label className="flex items-center gap-2 mb-3">
              <input
                type="checkbox"
                onChange={(e) =>
                  setForm({ ...form, is_global: e.target.checked ? 1 : 0 })
                }
              />
              <span>Hacer global</span>
            </label>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowAppModal(false)}
                className="bg-gray-700 px-3 py-1 rounded"
              >
                Cancelar
              </button>

              <button
                onClick={createApp}
                className="bg-blue-600 px-3 py-1 rounded hover:bg-blue-500"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===================== MODAL EDITAR APP ===================== */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center">
          <div className="bg-gray-900 p-6 rounded w-96">
            <h2 className="text-xl font-bold mb-4">Editar Meta App</h2>

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="App ID"
              value={form.app_id}
              onChange={(e) => setForm({ ...form, app_id: e.target.value })}
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="App Secret"
              value={form.app_secret}
              onChange={(e) =>
                setForm({ ...form, app_secret: e.target.value })
              }
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="Redirect URI"
              value={form.redirect_uri}
              onChange={(e) =>
                setForm({ ...form, redirect_uri: e.target.value })
              }
            />

            <input
              className="bg-gray-800 p-2 rounded w-full mb-2"
              placeholder="Nombre (opcional)"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <label className="flex items-center gap-2 mb-3">
              <input
                type="checkbox"
                checked={form.is_global === 1}
                onChange={(e) =>
                  setForm({ ...form, is_global: e.target.checked ? 1 : 0 })
                }
              />
              <span>Hacer global</span>
            </label>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowEditModal(false)}
                className="bg-gray-700 px-3 py-1 rounded"
              >
                Cancelar
              </button>

              <button
                onClick={updateApp}
                className="bg-blue-600 px-3 py-1 rounded hover:bg-blue-500"
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
